import assetPath from '/opt/actions-runner/_work/crate/crate/packages/entity-pages/entity-pages-employees/src/assets/card-blur.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')